import { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";

// Hook: load site settings + expose save
export default function useSettings() {
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/settings");
      setForm(data);
    })();
  }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async (override) => {
    setLoading(true);
    try {
      // Guard: when used as `onClick={save}`, React passes the click event as
      // first arg. We must NOT spread it into the payload (it has circular DOM
      // refs and breaks JSON.stringify, causing a silent "Failed to save"). Only
      // accept plain objects as override.
      const isPlainOverride =
        override &&
        typeof override === "object" &&
        !override.nativeEvent &&
        !override._reactName &&
        !(typeof Event !== "undefined" && override instanceof Event);
      const payload = isPlainOverride
        ? { ...(form || {}), ...override }
        : form;
      const { data } = await api.put("/settings", payload);
      setForm(data);
      toast.success("Configuration saved");
    } catch {
      toast.error("Failed to save configuration");
    } finally {
      setLoading(false);
    }
  };

  return { form, set, save, loading };
}
